import { ISeance } from '../../types/seance';
import GeneralEnum from '../../enumerables/general-enum';
import SeanceEnum from '../../enumerables/seance-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupSeanceToCsv = (data: ISeance[]) => {
    const groupData: any = [
        [
            'id',
            'Provider',
            'Student',
            'Vendor',
            'District',
            'Case Number',
            'Service Type',
            'Service Location',
            'Substituted',
            'External Eval Hourly Rate',
            'External Rate Per Hour',
            'Internal Rate Per Hour',
            'Date',
            'Start Time',
            'End Time',
            'Status',
            'Confirmation Date',
            'Confirmed On Time',
        ],
    ];
    const statusEnum = SeanceEnum ? SeanceEnum.getEnum('SeanceStatus') : {};

    const statuses: SelectObject[] = getValFromEnum(statusEnum);

    data.forEach((it) => {
        const providerTitle: string = it?.provider?.fullName ? it.provider?.fullName : '';
        const vendor: string = it.vendor?.name ? it.vendor?.name : '';

        const caseNumber: any = it.occasion?.caseNumber;

        const student = it.student ? `${it.student?.firstName} ${it.student?.lastName}` : '';
        const district: any = it?.district ? it?.district.name : '';

        let serviceType = it?.serviceType?.title;
        if (!serviceType) {
            serviceType = it?.serviceType?.cpt;
        }
        const serviceLocation = it?.serviceLocation?.title;
        const seanceDate = it?.seanceDate ? changeToZeroMoment(it.seanceDate, 'MMM D, YYYY') : '';

        const confirmDate = it?.confirmationDate ? changeToZeroMoment(it.confirmationDate, 'MMM D, YYYY') : '';

        const startTime = it?.startTime ? changeToZeroMoment(it.startTime, 'LT') : '';

        const endTime = it?.endTime ? changeToZeroMoment(it.endTime, 'LT') : '';

        const substitutedProvider = it?.substitutedProvider?.fullName ? it?.substitutedProvider?.fullName : '';

        let valuestatus: any = statuses.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? valuestatus.label : '';

        groupData.push([
            it.id,
            providerTitle,
            student,
            vendor ? vendor : '',
            district ? district : '',
            caseNumber ? caseNumber : 0,
            serviceType ? serviceType : '',
            serviceLocation ? serviceLocation : '',
            substitutedProvider ? substitutedProvider : '',
            it?.externalEvalHourlyRate ? `$${numberWithCommas(it?.externalEvalHourlyRate)}` : '$0.00',
            it?.externalRatePerHour ? `$${numberWithCommas(it?.externalRatePerHour)}` : '$0.00',
            it?.internalRatePerHour ? `$${numberWithCommas(it?.internalRatePerHour)}` : '$0.00',
            seanceDate,
            startTime,
            endTime,
            valuestatus ? valuestatus : '',
            confirmDate,
            it.status == 4 ? it.isConfirmInTime ? 'yes' : 'no' : '',
        ]);
    });

    return groupData;
};
